import React from 'react';

import bannerImage from '../assets/hearthlowe_banner_clean_v2.png';

const HomeBannerSection = () => {
  return (
    <section className="py-16 md:py-20 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl shadow-xl border border-black/5">
          {/* Background image */}
          <div className="absolute inset-0">
            <img
              src={bannerImage}
              alt="Rustic bread-making scene"
              className="w-full h-full object-cover scale-105 blur-[2px]"
            />
            {/* Soft overlays for readability */}
            <div className="absolute inset-0 bg-[#f7f5f2]/55" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#f7f5f2]/80 via-[#f7f5f2]/60 to-transparent" />
          </div>

          {/* Content */}
          <div className="relative px-8 py-12 md:px-12 md:py-14 max-w-2xl">
            <p className="text-xs tracking-widest uppercase text-[#243B29]/80 mb-3">
              Beginner-friendly support
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e1919] leading-tight mb-4">
              Start Sourdough with Confidence
            </h2>
            <p className="text-base md:text-lg text-[#736c64] leading-relaxed">
              A beginner-friendly kit—plus step-by-step guidance and support when you need it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBannerSection;
